
export default {
  documents: state => state.all,
  allShares: state => state.allShares,
  lastDoc: state => state.lastDoc,
};
